module.exports = __webpack_public_path__ + "img/fb-preview.14709092.svg";